import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PersonIcon from '@mui/icons-material/Person';

const ProfileSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box marginLeft={theme.spacing(2)}>
      <Button
        onClick={() => navigate('/app/profile')}
        sx={{ display: { xs: 'none', sm: 'block' }, textTransform: 'none' }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <PersonIcon sx={{ color: 'primary.main' }} />
          <Typography variant ='h3' sx={{ color: 'primary.main' }}><b>Profile</b></Typography>
        </Stack>
      </Button>
   
    </Box>
  );
};

export default ProfileSection;
